<app-layout *ngIf="game">

  <header class="hero--file">
      <app-base-section>
        <div class="breadcrumbs">
          <a
            [routerLink]="'/bv/jeux/'"
            class="link link--sm breadcrumbs__link" [ngClass]="game.topic">
            <span class="icon icon-chevron-sm icon--rotate-right"></span><span
            class="link__text">{{'Common.Library.games' |translate}}</span>
          </a>
        </div>
      </app-base-section>

      <app-base-section [isNarrow]="true" [noRight]="true">
        <div class="game__presentation__wrapper">
          <div class="game__presentation__inner-content">
            <div class="hero__tags">
              <div class="hero__tags__container">
                <app-tag-list *ngIf="game.tags" [hub]="game.topic" [tags]="game.tags" [buttonBehaviour]= "'nav'"></app-tag-list>

              </div>


              <div class="file__top__social">
                <app-sharer></app-sharer>
              </div>
            </div>

            <h1 class="title title--h1 hero__title">{{game.title}}</h1>
            <span class="caption">{{'Common.Library.' + game.topic|translate}}{{' '}}</span>
            <div class="hero__caption hero__modifier" *ngFor="let level of levels">
              <span class="caption">{{' | '}}{{level.label}}</span>
              <span class="hero__caption__years">{{level.years}}</span>
            </div>

            <!-- Buttons to download and play -->
            <div class="game__button__wrapper">
              <div class="game__button__inner">

                <!-- Download - Deactivated for now -->
                <div class="game__button__download__wrapper" *ngIf="(game.linkAppleStore || game.linkGooglePlay)">
                  <span class="caption game__caption">{{'Common.Actions.download_on'|translate}}</span>
                  <div class="app-store-butons">
                    <a
                      *ngIf="game.linkAppleStore"
                      class="icon icon-os-apple game__icon"
                      [href]="game.linkAppleStore"
                      target="_blank"
                      rel="noreferrer noopener"
                    ></a>
                    <a
                      *ngIf="game.linkGooglePlay"
                      class="icon icon-os-android game__icon"
                      [href]="game.linkGooglePlay"
                      target="_blank"
                      rel="noreferrer noopener"
                    ></a>
                  </div>

                  <!-- Play -->
                  <div class="game__button__play__wrapper" *ngIf="game.externalLink">
                    <ng-container>
                      <button class="btn btn--full game__btn">
                        {{'Common.Actions.play'|translate}}
                      </button>
                    </ng-container>
                    <a *ngIf="game.externalLink"
                      [href]="game.externalLink"
                      class="game__link"
                      rel="noreferrer noopener"
                      target="_blank">
                      <span class="icon icon-arrow"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="game__presentation__image-inner">
            <img *ngIf="game.vignette" [src]="game.vignette.url" [alt]="game.vignette.alt">
          </div>
        </div>
      </app-base-section>
  </header>


  <div *ngIf="game.content.length" class="game-content">

    <app-base-section
      *ngFor="let element of game.content; let mi = index"
      [isNarrow]="true"
      [module]="element"
      [isFirst]="mi === 0"
      [isLast]="mi + 1 === game.content.length"
    >
        <app-image *ngIf="element.type === 'media'" [module]="element"></app-image>
        <app-video *ngIf="element.type === 'youtubeBlog'" [module]="element"></app-video>
        <app-text *ngIf="element.type === 'text'" [module]="element"></app-text>
    </app-base-section>
  </div>

  <div class="slider__wrapper" *ngIf="tiles && tiles.length">
    <div class="slider-section">
      <app-base-section>
        <header class="slider-section__header">
          <h3 class="title--h1alt">{{'Common.Actions.all_games'|translate}}</h3>
    
          <div class="slider-arrows slider-arrows--exercise">
            <div class="icon icon-arrow icon-arrow--move-left slider-arrow slider-arrow--prev" id="all-games-slider--prev"></div>
            <div class="icon icon-arrow icon-arrow--move-right slider-arrow slider-arrow--next" id="all-games-slider--next"></div>
          </div>
        </header>
      </app-base-section>
    
      <app-base-section [noRight]="true" [hasSlider]="true">
        <app-slider
          [additionalConfig]="{
              navigation: {
                prevEl: '#all-games-slider--prev',
                nextEl: '#all-games-slider--next'
              }
            }"
        >
          <div class="tile-wrapper swiper-slide" *ngFor="let tile of tiles">
            <app-tile
              [tile]="tile"
              [format]="'medium'"
              [context]="'slider'"
            ></app-tile>
          </div>
        </app-slider>
      </app-base-section>

    </div>
  </div>
  

</app-layout>
